import { TextFieldElement } from "react-hook-form-mui"; 

const inputTableStyle = {
    "& .MuiInputBase-root": {
        width: '140%',
        height: 'auto',
    },
};

export const CustomTextFieldElementEarthquake = ({
    name,
    control,
    label = '',
    onChange,
    errors,
  }) => (
    <TextFieldElement
        name={`earthquakes.${name}`}
        control={control}
        label={label}
        onChange={onChange}
        fullWidth
        FormHelperTextProps={{
            sx: {
                whiteSpace: "nowrap"
            }
        }}
        helperText={errors?.earthquakes?.[name]?.message}
        sx={{ mt: 1 }}
    />
)

export const CustomTextFieldElementCheckResult = ({
    name,
    index,
    control,
    label = '',
    onChange,
    minRows=1,
    maxRows=8
  }) => (
    <TextFieldElement
        name={`checkResults.${index}.${name}`}
        control={control}
        label={label}
        onChange={onChange}
        fullWidth
        multiline
        minRows={minRows}
        maxRows={maxRows}
        FormHelperTextProps={{
            sx: {
                whiteSpace: "pre-wrap"
            }
        }}
    />
)

export const CustomTextFieldElementCheckSummary = ({
    name,
    control,
    disabled,
    label = '',
    onChange,
    errors,
    sx=null
  }) => (
    <TextFieldElement
        sx={sx? sx:inputTableStyle}
        name={`checkSummarys.${name}`}
        control={control}
        label={label}
        disabled={disabled}
        onChange={onChange}
        helperText={errors?.checkSummarys?.[name]?.message}
        FormHelperTextProps={{
            sx: {
                whiteSpace: "nowrap",
            }
        }}
    />
)